// extracted by mini-css-extract-plugin
export default {"tooltip":"iW-z","arrow":"jW-z"};